module.exports = __webpack_public_path__ + "static/img/android8.6e00da40.jpg";